import { render } from "./group-edit.vue?vue&type=template&id=2b31cd10&scoped=true&ts=true"
import script from "./group-edit.vue?vue&type=script&lang=ts"
export * from "./group-edit.vue?vue&type=script&lang=ts"

import "./group-edit.vue?vue&type=style&index=0&id=2b31cd10&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b31cd10"]])

export default __exports__